import RequiredLabel from './RequiredLabel';
export default RequiredLabel;
